import styled from 'styled-components';

export const SwitchContainer = styled.div`
  position: relative;
  width: ${props => props.width};
  display: flex;
  background: #f1f0f6;
  border-radius: 30px;
  z-index: 1;
  padding: 2px;
  height: 32px;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: 1640px) {
    height: 36px;
    padding: 4px 2px;
  }
`;

export const Switch = styled.div`
  label {
    display: inline-block;
    width: calc(${props => props.width} / ${props => props.tabsCount});
    font-size: 0.7rem;
    color: #bfbfbf;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: color 200ms ease-out;
    @media only screen and (min-width: 1640px) {
      font-size: 0.8rem;
    }
  }
  .switch__indicator {
    width: calc(${props => props.width} / ${props => props.tabsCount});
    height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 30px;
    margin: 2px;
    transition: transform 600ms cubic-bezier(0.02, 0.94, 0.09, 0.97),
      background 300ms cubic-bezier(0.17, 0.67, 0.14, 1.03);
    transform: translateX(calc(100% * ${props => props.activeTab}));
    z-index: -1;
    @media only screen and (min-width: 1640px) {
      height: 36px;
    }
  }
  input:checked ~ .switch__indicator {
    background-image: linear-gradient(#b30080, #4d004d);
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  }
  input:checked ~ label {
    color: white;
  }
  input[type='radio'],
  input[type='radio']:not(:checked),
  input[type='radio']:checked {
    display: none;
  }
`;

export const StyledHeading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-size: 1rem;
    font-weight: 500;
    padding: 8px;
    border-radius: 8px;
    text-transform: uppercase;
    background-color: #f9df25;
    font-family: 'Oswald', sans-serif;
    letter-spacing: 1px;
    @media only screen and (min-width: 1640px) {
      padding: 12px;
      font-size: 1.2rem;
    }
  }
  p {
    font-size: 0.8rem;
    padding: 8px 0;
    @media only screen and (min-width: 1640px) {
      font-size: 1rem;
    }
  }
`;
